import { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { useParams, useNavigate } from "react-router-dom";
import BackButton from "../components/BackButton";
import InputField from "../components/InputField";
import SelectField from "../components/SelectField";
import Button from "../components/Button";
import api from "../api/api";
 
function ViewWhRequest() {
  const { request_id, warehouse_id } = useParams();
  const navigate = useNavigate();
 
  const [warehouse, setWarehouse] = useState(null);
  const [documents, setDocuments] = useState([]);
  const [requestId, setRequestId] = useState(null);
  const [loading, setLoading] = useState(true);
  // eslint-disable-next-line no-unused-vars
  const [error, setError] = useState(null);
 
  const [showConfirm, setShowConfirm] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
 
  useEffect(() => {
    const fetchRequestDetails = async () => {
      try {
        setLoading(true);
        const response = await api.get(
          `/wh-owner/request-details/${request_id}`
        );
        const { request, documents } = response.data;
 
        // Format the data for display
        setRequestId(request.id);
        setWarehouse({
          request: `${request.start_date} - ${request.end_date}`,
          available: "", // Initial value empty
          product: request.product_name,
          hsncode: request.HSN_code,
          units: request.total_unit.toString(),
          unit_type: request.unit_type,
          storage_type: request.storage_type,
          tare_weight: `${request.dead_weight}kg`,
          length: `${request.length}cm`,
          breadth: `${request.Breadth}cm`,
          volumetric_weight: `${request.volumetric_weight}kg`,
          description: request.product_information,
          skucode: request.sku_or_item_code || "",
          requirements: request.special_requirements || "",
          location: request.pincode, // Or parse from warehouse_ids if needed
          comments: request.comments || "",
        });
        setDocuments(documents);
      } catch (err) {
        console.error("Error fetching request details:", err);
        setError("Failed to load request details.");
      } finally {
        setLoading(false);
      }
    };
 
    if (request_id) {
      fetchRequestDetails();
    }
  }, [request_id]);
 
  const handleConfirm = async () => {
    setShowConfirm(false);
 
    if (!warehouse.available) {
      alert("Please select availability status.");
      return;
    }
 
    try {
      await api.post("/warehouse/confirm-availability", {
        request_id: parseInt(requestId),
        warehouse_id: parseInt(warehouse_id),
        availability_status: warehouse.available,
      });
      setShowSuccess(true);
    } catch (error) {
      console.error("Error confirming availability:", error);
      alert("Failed to confirm availability.");
    }
  };
 
  const handleViewClick = () => {
    const certificate = documents.find(
      (doc) => doc.document_type === "certificate"
    );
    if (certificate) {
      window.open(certificate.document_url, "_blank");
    } else {
      alert("No certificate available.");
    }
  };
 
  if (loading) {
    return (
      <>
        <BackButton />
          <div className="text-center">Loading...</div>
      </>
    );
  }
 
  if (error) {
    return (
      <>
        <BackButton />
          <div className="text-center text-danger">{error}</div>
      </>
    );
  }
 
  if (!warehouse) {
    return (
      <>
        <BackButton />
          <div className="text-center">Request not found.</div>
      </>
    );
  }
 
  const handleSuccessClose = () => {
    setShowSuccess(false);
    navigate("/warehouse-requests-owner");
  };
 
  return (
    <>
      <BackButton />
      <form>
        <div className="d-md-flex align-items-center justify-content-between mb-3 mb-md-4">
          <h2 className="page-title">Request Information</h2>
          <button
            className="btn  btn-primary mt-0"
            onClick={handleViewClick}
          >
            View Product Certificate
          </button>
        </div>
        <div className="row g-3 mb-4">
          <div className=" col-sm-6 col-md-4">
            <InputField
              label="Requested Dates"
              value={warehouse.request}
              disabled
            />
          </div>
          <div className=" col-sm-6 col-md-4 "></div>
          <div className=" col-sm-6 col-md-4 ">
            <SelectField
              label="Is Warehouse Available During Requested Dates"
              name="available"
              value={warehouse.available}
              options={[
                { label: "Available", value: "Available" },
                { label: "Not Available", value: "Not Available" },
              ]}
              disabled={false}
              onChange={(value) =>
                setWarehouse({ ...warehouse, available: value })
              }
            />
          </div>
        </div>
        <h2 className="page-title">Storage Requirements</h2>
        <div className="row g-3 mb-4">
          <div className="col-sm-6 col-md-4">
            <InputField
              label="Product Name"
              value={warehouse.product}
              disabled
            />
          </div>
          <div className="col-sm-6 col-md-4">
            <InputField label="HSN Code" value={warehouse.hsncode} disabled />
          </div>
          <div className="col-sm-6 col-md-4">
            <InputField
              label="Number of Units"
              value={warehouse.units}
              disabled
            />
          </div>
          <div className="col-sm-6 col-md-4">
            <InputField
              label="Unit Type"
              value={warehouse.unit_type}
              disabled
            />
          </div>
          <div className="col-sm-6 col-md-4">
            <InputField
              label="Storage Type"
              value={warehouse.storage_type}
              disabled
            />
          </div>
          <div className="col-sm-6 col-md-4">
            <InputField
              label="Tare Weight"
              value={warehouse.tare_weight}
              disabled
            />
          </div>
          <div className="col-sm-6 col-md-4">
            <InputField label="Length" value={warehouse.length} disabled />
          </div>
          <div className="col-sm-6 col-md-4">
            <InputField label="Breadth" value={warehouse.breadth} disabled />
          </div>
          <div className="col-sm-6 col-md-4">
            <InputField
              label="Volumetric Weight"
              value={warehouse.volumetric_weight}
              disabled
            />
          </div>
        </div>
        <h5 className="page-title">Inventory Details</h5>
        <div className="row g-3 mb-4">
          <div className="col-sm-6 col-md-4">
            <InputField
              label="Product Description"
              value={warehouse.description}
              disabled
            />
          </div>
          <div className="col-sm-6 col-md-4">
            <InputField
              label="SKU / Item Code"
              value={warehouse.skucode}
              disabled
            />
          </div>
          <div className="col-sm-6 col-md-4">
            <InputField
              label="Special Requirements"
              value={warehouse.requirements}
              disabled
            />
          </div>
        </div>
        <div className="row g-3 mb-4">
          <h5 className="page-title">Warehouse Preference</h5>
          <div className="col-sm-6 col-md-4">
            <InputField
              label="Preferred Location"
              value={warehouse.location}
              disabled
            />
          </div>
        </div>
 
        <div className="row g-3 mb-4">
          <h5 className="page-title">Additional Information</h5>
          <div className="col-sm-6 col-md-4">
            <InputField label="Comments" value={warehouse.comments} disabled />
          </div>
 
          <div className=" text-end mt-4">
            <Button
              text="Confirm Availability"
              variant="primary"
              onClick={() => setShowConfirm(true)}
            />
          </div>
        </div>
      </form>
      <Modal show={showConfirm} onHide={() => setShowConfirm(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Submission</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to submit this warehouse request?
        </Modal.Body>
        <Modal.Footer>
          <Button
            text="Cancel"
            variant="secondary"
            onClick={() => setShowConfirm(false)}
          />
          <Button text="Confirm" variant="primary" onClick={handleConfirm} />
        </Modal.Footer>
      </Modal>
      <Modal show={showSuccess} onHide={handleSuccessClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Success</Modal.Title>
        </Modal.Header>
        <Modal.Body>Warehouse request submitted successfully!</Modal.Body>
        <Modal.Footer>
          <Button text="OK" variant="success" onClick={handleSuccessClose} />
        </Modal.Footer>
      </Modal>
    </>
  );
}
 
export default ViewWhRequest;
 